import JustValidate from 'just-validate';
import Utils from '../../assets/scripts/utils/utils';
import OrderAuth from '../order/order-auth';
import Popups from '../../components/popups/popups';
import { getTelRules } from '../../assets/scripts/utils/validationRules';

class EditTel {
	constructor(el) {
		this.init(el);
	}

	init(el) {
		this.container = el;
		this.sections = this.container.querySelectorAll('.edit-tel__section');

		if (!this.container || !this.sections.length) return;

		this.activeSection = this.sections[0];
		this.activeSection.classList.add('_active');

		const form = this.container.querySelector('.edit-tel__form');
		// const inputs = {
		// 	tel: form.querySelector('#edit-tel'),
		// };

		// form.addEventListener('submit', (evt) => {
		// 	evt.preventDefault();

		// 	this.activeSection.classList.remove('_active');
		// 	this.sections[1].classList.add('_active');
		// 	this.activeSection = this.sections[1];

		// 	const popup = this.activeSection;
		// 	// const telText = popup.querySelector('.confirm-tel__tel');
		// 	// const code = inputs.tel.getAttribute('data-country-code');
		// 	const smsCodeForm = popup.querySelector('[data-confirm-tel-timeout]');

		// 	// telText.textContent = `${code} ${inputs.tel.value}`;

		// 	OrderAuth.showTimer(Number(smsCodeForm.getAttribute('data-confirm-tel-timeout')), smsCodeForm);
		// });

		this._initValidation();

		Popups.onOpen.add((name) => {
			if (Popups.getPopup(name).contains(form)) {
				this.reset();
			}
		});
	}
	_initValidation() {
		const form = this.container.querySelector('.edit-tel__form');

		if (!form) {
			return;
		}

		const submitButton = form.querySelector('button[type="submit"]');
		const telInput = form.querySelector('input');
		const telInputSelector = `#${telInput.id}`;

		if (form.inited) {
			return;
		}

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;

		validator
			.addField(telInputSelector, getTelRules(telInputSelector), {
				errorsContainer: Utils.getErrorContainer(telInputSelector),
			})
			.onValidate(({ isValid }) => {
				submitButton.disabled = !isValid;
			});

		telInput.addEventListener('countrychange', () => {
			setTimeout(() => {
				form.validator.validate();
			}, 50);
		});

		submitButton.disabled = !validator.isValid;
		form.inited = true;
	}
	reset() {
		const form = this.container.querySelector('.edit-tel__form');

		form.validator.destroy();
		form.inited = false;

		form.reset();
		this.activeSection?.classList.remove('_active');
		this.sections[0]?.classList.add('_active');
		this.activeSection = this.sections[0];

		this._initValidation();
	}
}

document.querySelectorAll('[data-edit-tel]').forEach((el) => new EditTel(el));

export default EditTel;
